import { httpService } from 'core-utilities';
import {
  getRobloxCreditBalanceUrlConfig,
  redeemRobuxUrlConfig
} from '../constants/robloxCreditUrlConstants';

export const getRobloxCreditBalance = () => {
  const urlConfig = getRobloxCreditBalanceUrlConfig();
  return httpService.get(urlConfig).then(({ data }) => data);
};

export const redeemRobux = () => {
  const urlConfig = redeemRobuxUrlConfig();
  return httpService.post(urlConfig);
};
